import React, { createContext, useState, useContext } from 'react';
import companyLogo from "../../assets/company.png"

const ImageContext = createContext();

export const useImageContext = () => useContext(ImageContext);

export const ImageProvider = ({ children }) => {
    const imageUrl = {companyLogo}

  return (
    <ImageContext.Provider value={{imageUrl}}>
      {children}
    </ImageContext.Provider>
  );
};